import { render, staticRenderFns } from "./ResumeView.vue?vue&type=template&id=2fe7ab34&scoped=true&"
import script from "./ResumeView.vue?vue&type=script&lang=js&"
export * from "./ResumeView.vue?vue&type=script&lang=js&"
import style0 from "./ResumeView.vue?vue&type=style&index=0&id=2fe7ab34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7ab34",
  null
  
)

export default component.exports